import type { ReactNode } from 'react';
import EmptyResult from './EmptyResult';

interface TableEmptyRowProps {
    colSpan: number;
    /** Custom empty content. When omitted, renders shared `EmptyResult`. */
    children?: ReactNode;
    className?: string;
}

/**
 * Empty state row for secondary/feature tables (offcanvas, object tabs, settings).
 * Do not use in main registry tables (Clients, Leads, Objects, Products, …).
 */
const TableEmptyRow = ({ colSpan, children, className }: TableEmptyRowProps) => (
    <tr>
        <td colSpan={colSpan} className={className}>
            {children !== undefined ? children : <EmptyResult />}
        </td>
    </tr>
);

export default TableEmptyRow;
